export const socialData = [
  //van youtube, twitter,facebook,linkedin y lleva type: y Link
  {
    type: "youtube",
    link: "https://www.youtube.com/channel/UCApMWhsdpOGoUePusHpDMMA",
  },
  {
    type: "twitter",
    link: "https://x.com/educa360_EdTech",
  },
  {
    type: "facebook",
    link: "https://m.facebook.com/Educa360EdTech/photos/?ref=page_internal&mt_nav=0",
  },
  {
    type: "linkedin",
    link: "https://www.linkedin.com/company/educa360-edtech/posts/?feedView=all",
  },
  {
    type: "instagram",
    link: "https://www.instagram.com/educa360/",
  },
];
